import { CHECKOUT_ACTION_RESUME_FULFILLMENT, CHECKOUT_ACTION_REMOVE_EXPIRED_DAYS } from '../api/constants';

function callableErrorMessageLower(error: unknown): string {
    if (error instanceof Error) {
        return error.message.toLowerCase();
    }
    if (typeof error === 'object' && error !== null && 'message' in error) {
        return String((error as { message?: unknown }).message).toLowerCase();
    }
    return '';
}

/** Server mutex when client + webhook both fulfill — safe to retry, not a real failure. */
export function isFulfillmentConcurrencyError(error: unknown): boolean {
    const msg = callableErrorMessageLower(error);
    return msg.includes('already being registered') || msg.includes('καταχωρούνται ήδη');
}

/** Callable rejected re-initiate / duplicate payment — client should run placeBasketOrders. */
export function isCheckoutResumeFulfillmentError(error: unknown): boolean {
    if (typeof error !== 'object' || error === null) {
        return false;
    }
    const details = (error as { details?: { checkoutAction?: string } }).details;
    return details?.checkoutAction === CHECKOUT_ACTION_RESUME_FULFILLMENT;
}

export function isCheckoutRemoveExpiredDaysError(error: unknown): boolean {
    if (typeof error !== 'object' || error === null) {
        return false;
    }
    const details = (error as { details?: { checkoutAction?: string } }).details;
    return details?.checkoutAction === CHECKOUT_ACTION_REMOVE_EXPIRED_DAYS;
}

export function getCheckoutExpiredDates(error: unknown): string[] {
    if (typeof error !== 'object' || error === null) {
        return [];
    }
    const expiredDates = (error as { details?: { expiredDates?: unknown } }).details?.expiredDates;
    if (!Array.isArray(expiredDates)) {
        return [];
    }
    return expiredDates.filter((d): d is string => typeof d === 'string');
}

export { CHECKOUT_ACTION_REMOVE_EXPIRED_DAYS };

/**
 * Post-Viva / webhook timing and fulfillment mutex — retried by BasketProvider / OrderApp.
 * After retries exhaust the user still sees the message; not a Sentry bug (LUNCHBOX-5W).
 */
export function isFulfillmentTransientCallableError(error: unknown): boolean {
    if (isFulfillmentConcurrencyError(error) || isCheckoutResumeFulfillmentError(error)) {
        return true;
    }
    const msg = callableErrorMessageLower(error);
    return msg.includes('insufficient balance')
        || msg.includes('ανεπαρκές')
        || msg.includes('payment has not been confirmed')
        || msg.includes('δεν έχει επιβεβαιωθεί')
        || msg.includes('payment record not found')
        || msg.includes('πληρωμή δεν βρέθηκε')
        || msg.includes('still need to be registered')
        || msg.includes('εκκρεμούν καταχώρηση');
}
